<template>
 <div class="flex justify-end mt-3">
  <button
    id="pub-help-button"
    class="inline-flex items-center gap-1.5 px-3 py-1.5 text-[12px] text-gray-500 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:text-gray-700 transition-colors shadow-sm"
    @click="startTour"
    title="도움말 보기"
  >
    <i class="mdi mdi-help-circle-outline text-base"></i>
    가이드
  </button>
</div>

 <aside class="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-12 mt-3">
  <DashboardCard
    id="pub-tour-projects"
    title="전체 프로젝트"
    :buttons="totalProjectBtns"
    buttonId="pub-tour-project-btns"
    cardClass="h-[480px]"
  >
   <template #title>
    <div class="relative">
    <img
      :src="adjust"
      alt="adjust-icon"
      class="ml-[10px] mb-[2px] cursor-pointer"
      @click="isPopoverOpen = !isPopoverOpen"
    />
    <div
      v-if="isPopoverOpen"
      class="absolute top-full left-0 mt-2 bg-white border border-gray-02 rounded-lg shadow-md p-4 z-50 min-w-[240px]"
    >
      <div class="flex flex-col gap-3">
        <div>
          <div class="text-gray-05 text-sm font-medium mb-2 text-left">정렬</div>
          <select 
            v-model="sortOption" 
            class="w-full border border-gray-02 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-gray-03"
          >
            <option value="name">프로젝트명 오름차순</option>
            <option value="date">생성날짜 오름차순</option>
          </select>
        </div>
        
        <div class="text-sm font-medium mt-2">필터</div>
        <input
          v-model="filterText"
          placeholder="프로젝트명 검색"
          class="w-full border border-gray-02 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-gray-03"
        />
      </div>
    </div>
  </div>
   </template>
   <template #cardContents>
    <AllProjectList
      :projects="allProject"
      :sort-option="sortOption"
      :filter-text="filterText"
      v-model:parents="checkedParents"
      v-model:children="checkedChildren"
      @update:parents="(val) => checkedParents = val"
      @update:children="(val) => checkedChildren = val"
      @onClick="(project) => {
        isOpen = true;
        getProjectDetail(project);
      }"
    />
   </template>
  </DashboardCard>

  <div class="flex flex-col gap-[6px]">
    <!-- 첫 번째 카드: 신규 프로젝트 등록 -->
    <div id="pub-tour-new-project" class="relative">
      <div class="rounded-2xl overflow-hidden bg-white/70 backdrop-blur-sm border border-white/60 shadow-[0_4px_24px_rgba(0,0,0,0.06)]">
        <!-- 헤더 -->
        <div class="bg-slate-800 h-[53px] px-[25px] flex items-center">
          <h2 class="text-white text-[20px] font-semibold tracking-tight">신규 프로젝트 등록</h2>
        </div>
        
        <div class="bg-white p-3 h-[150px]">
          <!-- 프로젝트 검색 -->
          <div class="flex items-center gap-3 mb-2">
            <div class="flex-1 relative">
              <Input
                placeholder="프로젝트 검색"
                class="w-full h-[27px] rounded-[7px] bg-[#EDEDED]"
                inputClass="text-[10px] placeholder:text-[#A5A5A5]"
                v-model="searchData.projectName"
                readonly
              >
                <template #icon>
                  <img
                    :src="search"
                    alt="search"
                    class="ml-[9px] mr-2 w-[13px] h-[13px]"
                  />
                </template>
              </Input>
            </div>
            <button
              class="w-[49px] h-[25px] font-semibold text-[16px]"
              @click="() => { isSearchedProject = true }"
            >검색</button>
          </div>
          
          <!-- 참여자 검색 -->
          <div class="flex items-center gap-3 mb-2">
            <div class="flex-1 relative">
              <Input
                placeholder="프로젝트 참여 인원"
                class="w-full h-[27px] rounded-[7px] bg-[#EDEDED]"
                inputClass="text-[10px] placeholder:text-[#A5A5A5]"
                v-model="searchData.workersCount"
                readonly
              >
                <template #icon>
                  <img
                    :src="userIcon"
                    alt="user"
                    class="ml-[9px] mr-2 w-[14px] h-[14px]"
                  />
                </template>
              </Input>
            </div>
            <button
              class="w-[49px] h-[25px] font-semibold text-[16px]"
              @click="() => { isSearchedWorker = true }"
            >추가</button>
          </div>
          
          <!-- 참여자 태그 -->
          <div class="flex items-center gap-[6px] flex-wrap ml-[3px]">
            <Tag
              v-for="(worker) in searchData.workersOriginName"
              :key="worker"
              :label="worker.name"
              :class="worker.class + ' text-[7px] py-0 h-[14px] rounded-[7px]'"
            />
            <DeletableTag
              v-for="(worker) in searchData.workersAddName"
              :key="worker"
              :label="worker.name"
              :tagClass="worker.class + ' text-[7px] py-0 h-[14px] rounded-[7px]'"
              @handleClick="() => removeWorker(worker)"
            />
          </div>
        </div>
      </div>
      
      <!-- 등록 버튼 위치 조정 -->
      <div class="flex justify-end mt-1 mb-1">
        <button
          class="bg-violet-50 text-violet-700 border border-violet-200 w-[81px] h-[28px] rounded-[7px] text-[13px] font-semibold flex items-center justify-center hover:bg-violet-100 transition-all"
          @click="createNewProject"
        >등록</button>
      </div>
    </div>
    
    <!-- 두 번째 카드: 실시간 크롤링 등록 -->
    <div id="pub-tour-crawling" class="relative">
      <div class="rounded-2xl overflow-hidden bg-white/70 backdrop-blur-sm border border-white/60 shadow-[0_4px_24px_rgba(0,0,0,0.06)]">
        <!-- 헤더 -->
        <div class="bg-slate-800 h-[53px] px-[25px] flex items-center">
          <h2 class="text-white text-[20px] font-semibold tracking-tight">실시간 크롤링 등록</h2>
        </div>
        
        <!-- 내용 부분 (높이와 패딩 줄임) -->
        <div class="bg-white p-3 h-[180px]">
          <!-- 탭 버튼 -->
          <div class="flex gap-2 mb-2">
            <button 
              class="px-4 py-1 text-[12px] rounded-md"
              :class="activeTab === 'crawling' ? 'bg-violet-100 text-violet-700 border border-violet-200' : 'bg-gray-100 text-gray-500'"
              @click="activeTab = 'crawling'"
            >크롤링 키워드 등록</button>
            <!-- <button 
              class="px-4 py-1 text-[12px] rounded-md"
              :class="activeTab === 'hashtag' ? 'bg-violet-100 text-violet-700 border border-violet-200' : 'bg-gray-100 text-gray-500'"
              @click="activeTab = 'hashtag'"
            >해시태그 등록</button>
            <button 
              class="px-4 py-1 text-[12px] rounded-md"
              :class="activeTab === 'influencer' ? 'bg-violet-100 text-violet-700 border border-violet-200' : 'bg-gray-100 text-gray-500'"
              @click="activeTab = 'influencer'"
            >인플루언서 등록</button> -->
          </div>
          
          <!-- 탭 내용들 -->
          <div v-if="activeTab === 'crawling'" class="mb-3">
            <!-- 입력 + AND/NOT 버튼 -->
            <div class="mb-2 flex items-center gap-3">
              <input 
                type="text" 
                placeholder="크롤링 키워드 등록" 
                v-model="crawlingKeywordText"
                class="flex-1 h-[27px] px-3 rounded-[7px] bg-[#EDEDED] text-[10px] border-none focus:outline-none placeholder:text-[#A5A5A5]"
              >
              <div class="flex gap-1">
                <button 
                  class="w-[40px] h-[25px] font-semibold text-[12px] bg-[#01BAEF] text-white rounded-[5px] hover:opacity-90"
                  @click="addCrawlingKeyword('AND')"
                >AND</button>
                <button 
                  class="w-[40px] h-[25px] font-semibold text-[12px] bg-[#EF426F] text-white rounded-[5px] hover:opacity-90"
                  @click="addCrawlingKeyword('NOT')"
                >NOT</button>
              </div>
            </div>
            
            <!-- 동적으로 추가된 키워드 태그들 (삭제 가능) -->
            <div class="flex flex-wrap gap-2 ml-[3px] mb-2">
              <div 
                v-for="(keyword, index) in crawlingKeywords" 
                :key="index" 
                :class="[keyword.type === 'AND' ? 'bg-[#01BAEF]' : 'bg-[#EF426F]', 'text-white rounded-[7px] flex items-center px-2 py-1 text-[10px] font-semibold']"
              >
                <span>{{ keyword.text }}</span>
                <button class="ml-1" @click="removeCrawlingKeyword(index)">x</button>
              </div>
            </div>
            
            <!-- 기존 라디오 버튼 그룹 등 나머지 내용 -->
            <div class="flex flex-wrap gap-3 mb-2">
              <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="언론" class="mr-1" checked @change="handleChannelSelection" /> 언론
              </label>
              <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="블로그" class="mr-1" @change="handleChannelSelection" /> 블로그
              </label>
              <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="지식인" class="mr-1" @change="handleChannelSelection" /> 지식인
              </label>
              <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="카페" class="mr-1" @change="handleChannelSelection" /> 카페
              </label>
              <!-- <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="X" class="mr-1" @change="handleChannelSelection" /> X
              </label> -->
              <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="커뮤니티" class="mr-1" @change="handleChannelSelection" /> 커뮤니티
              </label>
              
              <label class="flex items-center text-[10px]">
                <input type="checkbox" name="source" value="유튜브" class="mr-1" @change="handleChannelSelection" /> 유튜브
              </label>
            </div>
            
            <!-- 작업 이름 입력 필드 추가 -->
            <!-- <div class="mb-2">
              <input 
                type="text" 
                placeholder="작업 이름 입력 (선택사항)" 
                v-model="realtimeCrawlingJobName"
                class="w-full h-[27px] px-3 rounded-[7px] bg-[#EDEDED] text-[10px] border-none focus:outline-none placeholder:text-[#A5A5A5]"
              >
            </div> -->
            
            <!-- 날짜 선택 필드 등 기존 내용 그대로 -->
            <div class="flex items-center mb-2 relative">
              <span class="text-[10px] mr-2">크롤링 기간:</span>
              <input 
                type="date" 
                class="p-1 border rounded-[7px] text-[10px] relative z-10"
                v-model="searchData.startDate"
                @click.stop
              >
              <span class="mx-2">~</span>
              <input 
                type="date" 
                class="p-1 border rounded-[7px] text-[10px] relative z-10"
                v-model="searchData.endDate"
                @click.stop
              >
              <!--
              <select 
                class="ml-2 p-1 border rounded-[7px] text-[10px] relative z-10"
                v-model="searchData.dateRange"
                @click.stop
              >
                <option value="1h" selected>1hour</option>  
                <option value="1d">1day</option>
                <option value="1w">1week</option>
              </select>
              -->
            </div>
          </div>
          
          <div v-if="activeTab === 'hashtag'" class="mb-3">
            <div class="mb-2 flex items-center gap-3">
              <input 
                type="text" 
                placeholder="해시태그 입력" 
                class="flex-1 h-[27px] px-3 rounded-[7px] bg-[#EDEDED] text-[10px] border-none focus:outline-none placeholder:text-[#A5A5A5]"
              >
              <button 
                class="w-[49px] h-[25px] font-semibold text-[16px]"
              >추가</button>
            </div>
            
            <div class="flex items-center flex-wrap gap-2 mb-2 ml-[3px]">
              <div class="bg-[#EF426F] text-white w-[40px] h-[14px] rounded-[7px] flex items-center justify-center text-[7px] font-semibold">
                #트렌드
              </div>
              <div class="bg-[#01BAEF] text-white w-[40px] h-[14px] rounded-[7px] flex items-center justify-center text-[7px] font-semibold">
                #마케팅
              </div>
            </div>
          </div>
          
          <div v-if="activeTab === 'influencer'" class="mb-3">
            <div class="mb-2 flex items-center gap-3">
              <input 
                type="text" 
                placeholder="인플루언서 검색" 
                class="flex-1 h-[27px] px-3 rounded-[7px] bg-[#EDEDED] text-[10px] border-none focus:outline-none placeholder:text-[#A5A5A5]"
              >
              <button 
                class="w-[49px] h-[25px] font-semibold text-[16px]"
              >검색</button>
            </div>
            
            <div class="flex items-center mb-2">
              <select class="w-full h-[27px] px-3 rounded-[7px] bg-[#EDEDED] text-[10px] border-none focus:outline-none">
                <option value="" disabled selected>카테고리 선택</option>
                <option value="beauty">뷰티</option>
                <option value="fashion">패션</option>
                <option value="food">음식</option>
                <option value="travel">여행</option>
              </select>
            </div>
            
            <div class="flex items-center flex-wrap gap-2 ml-[3px]">
              <div class="bg-[#9BCD65] text-white w-[60px] h-[14px] rounded-[7px] flex items-center justify-center text-[7px] font-semibold">
                @influencer1
              </div>
              <div class="bg-[#6DDABF] text-white w-[60px] h-[14px] rounded-[7px] flex items-center justify-center text-[7px] font-semibold">
                @influencer2
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 등록 버튼 위치 조정 -->
      <div class="flex justify-end mt-1">
        <button 
          class="w-[81px] h-[28px] rounded-[7px] text-[13px] font-semibold flex items-center justify-center"
          :class="selectedProjectCount > 0 ? 'bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100' : 'bg-gray-200 text-gray-400 cursor-not-allowed'"
          :disabled="selectedProjectCount === 0"
          @click="registerRealtimeCrawler"
        >등록</button>
      </div>
    </div>
  </div>
 </aside>
 
 <Carousel
   id="pub-tour-history"
   v-model="conversationHistory"
   @showMessage="handleMessage"
 />
 <Modal v-model="isOpen">
  <ProjectDetail v-model="detailData" />
 </Modal>
 <Modal
   v-model="isSearchedProject"
   modalClass="px-0 pt-0"
 >
  <ProjectSearch @selected="handleProjectSelected" />
 </Modal>
 <Modal
   v-model="isSearchedWorker"
   modalClass="px-0 pt-0"
 >
  <WorkerSearch @selected="handleUserSelected" />
 </Modal>
</template>

<script setup>
import { reactive, ref, computed, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import adjust from '@/assets/adjust.svg'
import search from '@/assets/search.svg'
import userIcon from '@/assets/user.svg'
import store from '@/store'
import DashboardCard from '@/components/ui/DashboardCard.vue'
import Tag from '@/components/ui/Tag.vue';
import Input from '@/components/ui/Input.vue';
import AllProjectList from '@/components/AllProjectList.vue'
import Carousel from '@/components/Carousel.vue';
import Modal from '@/components/ui/Modal.vue'
import ProjectDetail from '@/components/ProjectDetail.vue'
import ProjectSearch from '@/components/ProjectSearch.vue'
import WorkerSearch from '@/components/WorkerSearch.vue'
import DeletableTag from '@/components/ui/DeletableTag.vue'


// ========== 투어 가이드 ==========
const driverObj = ref(null)

function startTour() {
  nextTick(() => {
    driverObj.value = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      overlayClickNext: false,
      stagePadding: 10,
      nextBtnText: '다음',
      prevBtnText: '이전',
      doneBtnText: '완료',
      progressText: '{{current}} / {{total}}',
      steps: [
        {
          element: '#pub-tour-projects',
          popover: {
            title: '📋 전체 프로젝트',
            description: '등록된 프로젝트 목록입니다.<br/><br/><b>프로젝트 제목을 클릭</b>하면 크롤링 상세 내역과 프로젝트 정보를 확인할 수 있습니다.',
            side: 'right',
            align: 'start'
          }
        },
        {
          element: '#pub-tour-project-btns',
          popover: {
            title: '🚀 프로젝트 기능 버튼',
            description: '프로젝트를 <b>체크박스로 선택</b>한 뒤, 아래 버튼으로 이동합니다.<br/><br/>• <b>대시보드</b>: 데이터 시각화 분석<br/>• <b>알림 등록</b>: 키워드 알림 설정<br/>• <b>대화 생성</b>: AI 채팅 시작<br/>• <b>선택 취소</b>: 선택 초기화',
            side: 'top',
            align: 'end'
          }
        },
        {
          element: '#pub-tour-new-project',
          popover: {
            title: '📁 신규 프로젝트 등록',
            description: 'GIG에서 프로젝트를 검색하여 새 프로젝트를 등록합니다.<br/><br/>• <b>검색</b> 버튼으로 프로젝트 찾기<br/>• <b>추가</b> 버튼으로 참여 인원 지정<br/>• 설정 후 <b>등록</b> 버튼 클릭',
            side: 'left',
            align: 'start'
          }
        },
        {
          element: '#pub-tour-crawling',
          popover: {
            title: '🔄 실시간 크롤링 등록',
            description: '프로젝트를 선택한 뒤, 크롤링 키워드와 조건을 설정합니다.<br/><br/>• <b>AND</b>: 포함 키워드 (최대 8개)<br/>• <b>NOT</b>: 제외 키워드<br/>• 채널, 기간 설정 후 <b>등록</b>',
            side: 'left',
            align: 'start'
          }
        },
        {
          element: '#pub-tour-history',
          popover: {
            title: '💬 최근 대화 내역',
            description: '이전에 생성한 대화 세션 목록입니다.<br/><br/>클릭하면 해당 대화로 바로 이동할 수 있습니다.',
            side: 'top',
            align: 'center'
          }
        },
        {
          element: '#pub-help-button',
          popover: {
            title: '❓ 도움말',
            description: '언제든지 이 버튼을 클릭하면 가이드를 다시 볼 수 있습니다.',
            side: 'bottom',
            align: 'end'
          }
        }
      ]
    })

    driverObj.value.drive()
  })
}

const conversationHistory = ref([])

async function getConversation() {
 try {
  await store.dispatch('chat/fetchChatSessions');
  conversationHistory.value = store.state.chat.sessions;
 } catch (error) {
  console.error(error)
 }
}

const allProject = ref([])
const checkedParents = ref([])
const checkedChildren = reactive({});

const currentUser = computed(() => store.state.auth.user)

//for popover
const isPopoverOpen = ref(false)
const sortOption = ref('name')
const filterText = ref('')


onMounted(() => {
  document.addEventListener('click', (e) => {
    const target = e.target
    if (!target.closest('.relative')) {
      isPopoverOpen.value = false
    }
  })
})

async function getProjectData() {
 try {
  // TODO: api
  await store.dispatch('project/fetchProjectCrawlings')

  allProject.value = store.state.project.projectCrawlings.map((parent) => ({
   ...parent, jobs: parent.crawling_jobs.reduce((acc) => {
    acc[parent.id] = parent.crawling_jobs;
    return acc;
   }, {})
  }));

  Object.assign(
   checkedChildren,
   allProject.value.reduce((acc, cur) => {
    if (cur?.crawling_jobs?.length) {
     acc[cur.id] = [];
    }
    return acc;
   }, {})
  );
 } catch (error) {
  console.error(error);
 }
}
const router = useRouter()
function genConversation() { 

 const ids = Object.values(checkedChildren).reduce((acc, cur) => {
  if (cur.length) {
   acc.push(...cur)
  } 
  return acc
 }, [])
 
 console.log('ids', ids)

 if (ids.length) {
  router.push({ name: 'ChatPub', query: { id: ids.join('|') } }) 
 }
 else { 
    store.commit('handleNotify', { message: '프로젝트를 선택해주세요.' }) 
 } 
 
}

function onClickNotification() {
  const parentIds = checkedParents.value;
  if (parentIds.length === 0) {
    store.commit('handleNotify', { message: '프로젝트를 선택해주세요.' });
    return;
  }

  if (parentIds.length > 1) {
    store.commit('handleNotify', { message: '하나의 프로젝트만 선택해주세요.' });
    return;
  }

  // ✅ 이 부분을 반드시 추가하세요
  const selectedProject = allProject.value.find(p => p.id === parentIds[0]);
  if (!selectedProject) {
    store.commit('handleNotify', { message: '선택한 프로젝트를 찾을 수 없습니다.' });
    return;
  }

  // 예: store에 저장하거나 query로 넘기기
  store.commit('notification/setSelectedProject', selectedProject); // 예시

  // 라우팅
  router.push(`/pub/notification/${parentIds[0]}`);
}


function onClickBtnDashborad() {
  const parentIds = checkedParents.value;
  if (parentIds.length === 0) {
    store.commit('handleNotify', { message: '프로젝트를 선택해주세요.' });
    return;
  }

  if (parentIds.length > 1) {
    store.commit('handleNotify', { message: '하나의 프로젝트만 선택해주세요.' });
    return;
  }

  // ✅ 이 부분을 반드시 추가하세요
  const selectedProject = allProject.value.find(p => p.id === parentIds[0]);
  if (!selectedProject) {
    store.commit('handleNotify', { message: '선택한 프로젝트를 찾을 수 없습니다.' });
    return;
  }
  
  // 라우팅
  router.push(`/pub/dashboardMain/${parentIds[0]}`);
}

// function onClickNotification() {
//   const parentIds = checkedParents.value;
//   const childIds = Object.values(checkedChildren).flat(); 

//   if (parentIds.length === 0) {
//     store.commit('handleNotify', { message: '프로젝트를 선택해주세요.' });
//     return;
//   }

//   if (parentIds.length > 1) {
//     store.commit('handleNotify', { message: '하나의 프로젝트만 선택해주세요.' });
//     return;
//   }


//   router.push({
//   path: `/pub/Notification/${parentIds[0]}`,
//     state: {
//       projectData: selectedProject
//     }
//   })

//   // // 🔥 완벽하게 작동하는 명시적 방식
//   // router.push(`/pub/Notification/${parentIds[0]}`)
// }

function handleCancel() {
  // 부모 체크박스 초기화
  checkedParents.value = [];
  
  // 자식 체크박스 초기화
  for (const key in checkedChildren) {
    checkedChildren[key] = [];
  }
  
  // AllProjectList 컴포넌트의 checkedAll 상태도 초기화하기 위해 이벤트 발생
  if (allProject.value.length > 0) {
    const event = new Event('update:model-value');
    event.value = false;
    document.dispatchEvent(event);
  }
}

const initSearchData = {
 workersCount: null,
 workersAddName: [],
 workersOriginName: [],
 projectName: '',
 startDate: '',
 endDate: '',
 dateRange: '1week'
}

const searchData = ref({...initSearchData})
const activeTab = ref('crawling')

async function createNewProject() {
  if (!searchData.value.projectName) { 
    store.commit('handleNotify', { message: '프로젝트를 선택해주세요.' })
    return
  }

  // const isDuplicate = allProject.value.some(project => 
  //   project.gig_project_id === searchData.value.prjct_pid
  // )

  // if (isDuplicate) {
  //   store.commit('handleNotify', { message: '이미 등록되어있는 프로젝트입니다.' })
  //   return
  // }

  console.log('searchData', searchData.value)
  const participantIds = searchData.value.workersAddName.length || searchData.value.workersOriginName?.length
    ? [...new Set([
        currentUser.value.pid,
        ...(searchData.value.workersAddName?.map(p => p.mber_pid) || []),
        ...(searchData.value.workersOriginName?.map(p => p.mber_pid) || [])  // workersOriginName의 mber_pid 추가
      ])]
    : [currentUser.value.pid]

  try {
    const newProject = {
      gig_project_id: searchData.value.prjct_pid,
      name: searchData.value.prjct_nm,
      description: searchData.value.prjct_contents || null,
      status: 'active',
      type: 'gig',
      start_date: searchData.value.prjct_bgng_dt || new Date().toISOString().split('T')[0],
      end_date: searchData.value.prjct_end_dt || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      participant_ids: participantIds
    }

    console.log('newProject', newProject);

    const result = await createProjectAction(newProject)
    // const result = { success: true }
    if (result.success) {
      store.commit('handleNotify', { message: '프로젝트가 성공적으로 생성되었습니다.', type: 'success' })
      searchData.value = { ...initSearchData }
      await getProjectData()
    } else {
      store.commit('handleNotify', { message: '프로젝트 생성에 실패했습니다.' })
    }
  } catch (error) {
    console.error('Failed to create project:', error)
    store.commit('handleNotify', { message: '프로젝트 생성 중 오류가 발생했습니다.' })
  }
}

async function createProjectAction(projectData) {
  return await store.dispatch('project/createProject', projectData)
}

const totalProjectBtns = [
{
  label: '대시보드',
  class: 'bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100',
  'onClick': () => onClickBtnDashborad()
},
{
  label: '알림 등록',
  class: 'bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100',
  'onClick': () => onClickNotification()
},
{
  label: '대화 생성',
  class: 'bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100',
  'onClick': () => genConversation()
 },
 {
  label: '선택 취소',
  class: 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-200',
  'onClick': () => handleCancel()
 }
]

const newProjectBtns = []

function init() {
 getConversation()
 getProjectData()
}
init()

const isOpen = ref(null)
const detailData = ref({
 name: '',
 lucyFile: null,
 workers: [],
 crawlStatus: [],
 projectRange: '',
})

async function getProjectDetail(project) {
 if (!project) return;

 detailData.value = project
}

const isSearchedProject = ref(false)
const isSearchedWorker = ref(false)

async function getProjectParticipants(selectedRow) {
 try {
  await store.dispatch('project/fetchProjectParticipants', selectedRow.prjct_pid)
  const res = store.state.project.projectParticipants

  searchData.value.workersOriginName = res.map((data) => ({
   name: `${data.mber_nm} (${data.dty_dv_code_nm}, ${data.dept_dv_code_nm})`,
   class: 'bg-gray-03',
   mber_pid: data.mber_pid  // mber_pid 추가
  }))
 } catch (error) {
  console.log(error)
 }
}

function handleProjectSelected(selectedRow) {
 isSearchedProject.value = false
 searchData.value = {
  ...selectedRow, 
  workersAddName: [],
  projectName: selectedRow.prjct_nm,
  workersCount: `${selectedRow.project_cnt} 명`,
 }
 getProjectParticipants(selectedRow)
 console.log('searchData', searchData.value)
}

function handleUserSelected(selectedRow) {
 isSearchedWorker.value = false
 const chipColors = [
  'bg-[#F6C753]',
  'bg-[#9BCD65]',
  'bg-[#6DDABF]',
  'bg-[#68C8EB]',
  'bg-[#B39EE9]',
 ]
 const randomIndex = () => Math.floor(Math.random() * chipColors.length);

 searchData.value = {
  ...searchData.value,
  workersCount: `${searchData.value.workersCount}, ${selectedRow.mber_nm}`
 }

 searchData.value.workersAddName.push({
    name: `${selectedRow.mber_nm} (${selectedRow.grd_dv_code_nm}, ${selectedRow.dept_dv_code_nm})`,
    class: chipColors[randomIndex()],
    mber_pid: selectedRow.mber_pid 
  })
}

function removeWorker(worker) {
 const users = searchData.value.workersCount.split(', ').filter((user) => !worker.name.includes(user))
 searchData.value.workersCount = users.join(', ')
 searchData.value.workersAddName = searchData.value.workersAddName.filter((user) => user.name !== worker.name)
}

/**
 * 알림 메시지 처리 함수
 * @param {string} message - 표시할 메시지
 */
function handleMessage(message) {
  store.commit('handleNotify', { 
    message, 
    type: 'success'  // 또는 실패 시 'error'
  });
  
  // 채팅 세션 목록 새로고침
  getConversation();
}

function goQaPage() {
  router.push('/pub/qa');
}

// 기존 activeTab 선언 아래에 추가
const crawlingKeywordText = ref('');
const crawlingKeywords = ref([]);
const selectedChannels = ref(['언론']); // 기본값으로 '언론' 선택
const realtimeCrawlingJobName = ref(''); // 작업 이름

/**
 * 입력된 텍스트가 있을 경우 AND/NOT 버튼 클릭 시 keyword 객체를 추가
 * @param {string} type - 'AND' 또는 'NOT'
 */
function addCrawlingKeyword(type) {

  // AND 키워드가 이미 8개 이상이면 추가 금지
  if (type === 'AND') {
    const andCount = crawlingKeywords.value.filter(k => k.type === 'AND').length;
    if (andCount >= 8) {
      store.commit('handleNotify', { message: 'AND 키워드는 최대 8개까지 추가할 수 있습니다.' }); 
      // alert("AND 키워드는 최대 8개까지 추가할 수 있습니다.");
      return;
    }
  }


  if (crawlingKeywordText.value.trim() !== '') {
    crawlingKeywords.value.push({
      text: crawlingKeywordText.value.trim(),
      type: type  // 'AND'면 파란색(#01BAEF), 'NOT'이면 빨간색(#EF426F)
    });
    crawlingKeywordText.value = '';
  }
}

/**
 * 지정한 인덱스의 crawling keyword를 삭제
 * @param {number} index 
 */
function removeCrawlingKeyword(index) {
  crawlingKeywords.value.splice(index, 1);
}

/**
 * 채널 선택을 처리하는 함수
 * @param {Event} event - 체크박스 이벤트
 */
function handleChannelSelection(event) {
  const value = event.target.value;
  if (event.target.checked) {
    if (!selectedChannels.value.includes(value)) {
      selectedChannels.value.push(value);
    }
  } else {
    selectedChannels.value = selectedChannels.value.filter(channel => channel !== value);
  }
}

// 선택된 프로젝트 개수를 계산하는 computed 속성
const selectedProjectCount = computed(() => {
  // 부모 프로젝트(checkedParents)의 개수
  const parentCount = checkedParents.value.length;
  
  // 자식 프로젝트(checkedChildren)의 개수
  let childCount = 0;
  for (const key in checkedChildren) {
    childCount += checkedChildren[key].length;
  }
  
  // 총 선택된 프로젝트 개수
  return parentCount + childCount;
});

/**
 * 실시간 크롤링 등록 처리
 */
async function registerRealtimeCrawler() {
  // 프로젝트 선택 검증
  if (selectedProjectCount === 0) {
    store.commit('handleNotify', { message: '프로젝트를 선택해주세요.' });
    return;
  }
  
  // 프로젝트 개수 검증 (하나만 선택되어야 함)
  if (selectedProjectCount > 1) {
    store.commit('handleNotify', { message: '하나의 프로젝트만 선택해야 합니다.' });
    return;
  }
  
  // 선택된 프로젝트 ID 찾기
  let selectedProjectId;
  
  if (checkedParents.value.length === 1) {
    // 부모 프로젝트가 선택된 경우
    selectedProjectId = checkedParents.value[0];
  } else {
    // 자식 프로젝트가 선택된 경우
    for (const parentId in checkedChildren) {
      if (checkedChildren[parentId].length === 1) {
        selectedProjectId = checkedChildren[parentId][0];
        break;
      }
    }
  }
  
  // AND 타입 키워드만 실제 키워드로 추가
  const andKeywords = crawlingKeywords.value
    .filter(keyword => keyword.type === 'AND')
    .map(keyword => keyword.text);
  
  // NOT 타입 키워드는 제외할 키워드로 추가
  const notKeywords = crawlingKeywords.value
    .filter(keyword => keyword.type === 'NOT')
    .map(keyword => keyword.text);
  
  // 키워드가 없는 경우
  if (andKeywords.length === 0) {
    store.commit('handleNotify', { message: '최소 하나 이상의 키워드를 등록해주세요.' });
    return;
  }
  
  // 날짜 유효성 검사
  if (new Date(searchData.value.endDate) < new Date(searchData.value.startDate)) {
    store.commit('handleNotify', { message: '종료일은 시작일보다 빠를 수 없습니다.' }); 
    return;
  }

  // 선택된 채널 매핑
  const channelMapping = {
    '언론': 'media',
    '블로그': 'blog',
    '인스타그램': 'instagram',
    'X': 'twitter',
    '카페': 'cafe',
    '유튜브': 'youtube',
    '커뮤니티': 'community',
    '지식인': 'knowledge'
  };
  
  const mappedChannels = selectedChannels.value.map(channel => channelMapping[channel] || channel);
  
  // frequency 매핑
  const frequencyMapping = {
    '1hour': '1h',
    '1day': '1d',
    '1week': '1w' 
  };
  
  // 프로젝트 이름 가져오기
  const selectedProject = allProject.value.find(project => project.id === selectedProjectId) || 
                         allProject.value.find(project => {
                           return project.crawling_jobs?.some(job => job.id === selectedProjectId);
                         });
  
  const projectName = selectedProject ? selectedProject.name : '선택된 프로젝트';
  
  // 기본 작업 이름 생성 (프로젝트명 + 현재 시간)
  const defaultJobName = `${projectName} 크롤링 ${new Date().toLocaleString('ko-KR')}`;
  
  try {
    const crawlerData = {
      project_id: selectedProjectId,
      job_name: realtimeCrawlingJobName.value || defaultJobName,
      keywords: andKeywords,
      excluded_keywords: notKeywords.length > 0 ? notKeywords : undefined,
      // frequency: frequencyMapping[searchData.value.dateRange] || '1day',
      frequency: '1h',
      channels: mappedChannels,
      mode: activeTab.value === 'crawling' ? 'portal' : 
            activeTab.value === 'hashtag' ? 'hashtag' : 'influencer',
      start_date: searchData.value.startDate || new Date().toISOString().split('T')[0],
      end_date: searchData.value.endDate || new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split('T')[0]
    };
    
    console.log('Creating realtime crawler with data:', crawlerData);
    
    const result = await store.dispatch('crawling/createRealtimeCrawler', crawlerData);
    
    if (result && result.success) {
      store.commit('handleNotify', { 
        message: '실시간 크롤링 작업이 성공적으로 등록되었습니다.', 
        type: 'success' 
      });
      
      // 폼 초기화
      crawlingKeywords.value = [];
      crawlingKeywordText.value = '';
      realtimeCrawlingJobName.value = '';
      
      // 프로젝트 데이터 새로고침
      await getProjectData();
    } else {
      throw new Error(result?.message || '등록에 실패했습니다.');
    }
  } catch (error) {
    console.error('Failed to register realtime crawler:', error);
    store.commit('handleNotify', { 
      message: error.message || '실시간 크롤링 등록 중 오류가 발생했습니다.' 
    });
  }
}

</script>
